import { GET_ABOUT_US_START } from '../../types';

export const get_about_us = (payload) => ({
  type: GET_ABOUT_US_START,
  payload,
});
